module.exports = __webpack_public_path__ + "static/media/pingpong.9bf8fb45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/pingpong.svg
// module id = 3341
// module chunks = 7